import { FlightRuleSearchResponse, FlightRuleCreateUpdateResponse } from '../../flights/model/flight-response';
import { TYPE_ERROR, TYPE_SUCCESS } from '../model';
import { UppNotification, DEFAULT_SUCCESS } from '../../model/notification';
import { TYPE_WARNING } from '../model/pos/pos-market-record';
import { JourneyUi, convertToJourneyUi, FlightRuleDeleteRequest } from '../../flights/model';
import { SUCCESS_STATUS, MISSING_RESULT_STATUS, UNKNOWN_RESULT_STATUS, buildErrorOrWarning } from './response-handler';
import { BaseResponse } from '../../base/model/base-response';

export const successDeleteJourneyUi: JourneyUi = {
  statusType: TYPE_SUCCESS,
  statusNotification: { success: [DEFAULT_SUCCESS] },
  rule: {
    id: '',
    organization: '',
    name: '',
    action: '',
    active: false
  },
  applicability: {
    pointOfSaleNames: []
  }
};

export const warningJourneyUi: JourneyUi = {
  statusType: TYPE_WARNING,
  statusNotification: { warning: [UNKNOWN_RESULT_STATUS] },
  rule: {
    id: 'flightRuleWarning',
    organization: '',
    name: '',
    action: '',
    active: false
  },
  applicability: {
    pointOfSaleNames: []
  }
};

export const errorJourneyUi: JourneyUi = {
  statusType: TYPE_ERROR,
  statusNotification: { error: [MISSING_RESULT_STATUS] },
  rule: {
    id: 'flightRuleError',
    organization: '',
    name: '',
    action: '',
    active: false
  },
  applicability: {
    pointOfSaleNames: []
  }
};

export const buildFlightFromCreateOrUpateResponse = (
  response: FlightRuleCreateUpdateResponse,
  isFareTypeEnabled = false
): JourneyUi => {
  if (response.status.state === SUCCESS_STATUS) {
    return createSuccessRuleForCreate(response, true, isFareTypeEnabled);
  }
  return buildFailedResponse(response);
};

export const buildFlightRuleListFromSearchResponse = (
  response: FlightRuleSearchResponse,
  isFareTypeEnabled = false,
  requestedPageSize = 10
): { journeys: JourneyUi[]; pagination?: { totalCount: number; currentPage: number; pageSize: number } } => {
  if (response.status.state === SUCCESS_STATUS) {
    const pagination = response.searchFollowUpResponse
      ? {
          totalCount: response.searchFollowUpResponse.totalRecords,
          currentPage: response.searchFollowUpResponse.currentPageNumber - 1,
          pageSize: requestedPageSize
        }
      : undefined;
    return {
      journeys: createFlightRuleList(response, isFareTypeEnabled),
      pagination
    };
  }
  return {
    journeys: [buildFailedResponse(response)]
  };
};

export const buildFlightRuleFromDeleteResponse = (
  response: BaseResponse,
  request: FlightRuleDeleteRequest
): JourneyUi => {
  if (response.status.state === SUCCESS_STATUS) {
    return {
      ...successDeleteJourneyUi,
      rule: {
        ...successDeleteJourneyUi.rule,
        id: request.journey.rule.id
      }
    };
  }

  return buildFailedResponse(response);
};

const buildFailedResponse = (response: BaseResponse): JourneyUi =>
  buildErrorOrWarning(warningJourneyUi, errorJourneyUi, response) as JourneyUi;

const createFlightRuleList = (response: FlightRuleSearchResponse, isFareTypeEnabled = false): JourneyUi[] => {
  const journeys: JourneyUi[] = [];
  response.journeys.forEach((journey) => journeys.push(convertToJourneyUi(journey, isFareTypeEnabled)));
  return journeys;
};

const createSuccessRuleForCreate = (
  response: FlightRuleCreateUpdateResponse,
  addLinkData: boolean,
  isFareTypeEnabled = false
): JourneyUi => {
  const notification: UppNotification = {
    success: [DEFAULT_SUCCESS]
  };

  if (!response.journey.rule.id) {
    throw new Error('id is null or undefined.');
  }

  if (addLinkData) {
    notification.links = [
      {
        id: response.journey.rule.id,
        name: response.journey.rule.name
      }
    ];
  }
  const flightRule = convertToJourneyUi(response.journey, isFareTypeEnabled);
  flightRule.statusType = TYPE_SUCCESS;
  flightRule.statusNotification = notification;
  return flightRule;
};
